export enum PersonFactKindEnum {
    BIO = 'bio',
    ANECDOTE = 'anecdote',
    WORK = 'work',
    QUOTE = 'quote',
    PLACE = 'place',
}
